import { faFacebookF, faTwitter, faWhatsapp, faTelegramPlane, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

export const socialNetwork = (url, title) => {
  const routeOrSchool = url?.includes('ruta') ? `Ruta` : `Escuela`;
  const whatsappCopy = url?.includes('ruta')
    ? `https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Ruta%20de%20Aprendizaje%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ${url}`
    : `https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Escuela%20de%20${title}%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ${url}`;
  return [
    {
      network: 'whatsapp',
      url: whatsappCopy,
      icon: faWhatsapp,
      class: 'whatsapp',
    },
    {
      network: 'twitter',
      url: `https://twitter.com/intent/tweet/?text=Inici%C3%A9%20la%20${routeOrSchool}%20de%20${title}%20en%20@platzi%20%F0%9F%92%9A%20Suscr%C3%ADbete%20y%20s%C3%A9%20parte%20de%20la%20comunidad%20de%20aprendizaje%20m%C3%A1s%20grande%20de%20Latinoam%C3%A9rica.%20${url}`,
      icon: faTwitter,
      class: 'twitter',
    },
    {
      network: 'telegram',
      url: `https://telegram.me/share/url?text=%C2%A1Mira!%20Encontr%C3%A9%20la%20${routeOrSchool}%20de%20${title}%20en%20Platzi%20%C2%BFy%20si%20la%20empezamos%20y%20aprendemos%20en%20comunidad?%20${url}`,
      icon: faTelegramPlane,
      class: 'telegram',
    },
    {
      network: 'facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      icon: faFacebookF,
      class: 'facebook',
    },
    {
      network: 'linkedin',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      icon: faLinkedinIn,
      class: 'linkedin',
    },
  ];
};
